import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import ConfiguratorTemplate from './ConfiguratorTemplate';
import { rem } from 'polished';

export const ConfiguratorStyled = styled(ConfiguratorTemplate)`
    .hideTechnicalDetailWrapper {
        display: none;
    }

    .isLoading {
        opacity: 0.5;
    }

    .spinnerPrice {
        position: absolute;
        top: 45%;
        left: 45%;
    }

    .specificationBlock {
        border-bottom: none;
        margin-bottom: ${rem(20)};
    }
`;
